<span *ngIf="statusLabel === 'Active'" class="badge bg-success">
  {{ statusLabel }}
</span>
<span *ngIf="statusLabel === 'Inactive'" class="badge bg-danger">
  {{ statusLabel }}
</span>